module.exports = __webpack_public_path__ + "img/image7.e3d69ad0.png";